import { useEffect, useState, Suspense } from 'react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { api_menu_list } from '../../../components/states/selector'
import { BrowserRouter, Route, Switch, Link, NavLink, useParams, useRouteMatch, useLocation, Redirect } from 'react-router-dom';



const ItemList = ()=>{
  let [ menu_list, setMenuList ] = useRecoilState(api_menu_list)
  useEffect(()=>{
    setMenuList(menu_list)
  }, [])

  return (
    <>
      <h2>ItemList</h2>
    </>
  )
}

export default ItemList;
